<template>
  <v-container fluid
    grid-list-xl
    py-0>
    <!-- Global filters -->
    <v-form
      id="global-filters"
      ref="form"
      v-model="form.valid"
      lazy-validation
      autocomplete="off"
      @submit.prevent="apply"
    >
      <v-layout justify-end>
        <v-flex xs5 md3 px-2>
          <v-menu
            :close-on-content-click="true"
            :nudge-right="40"
            v-model="menuStartDate"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="startDate"
              :rules="rules.startDate"
              label="Start date"
              color="deep-orange darken-1"
              prepend-icon="mdi-calendar"
              readonly />
            <v-date-picker v-model="startDate" no-title scrollable actions color="deep-orange darken-1"/>
          </v-menu>
        </v-flex>
        <v-flex xs5 md3 px-2>
          <v-menu
            :close-on-content-click="true"
            v-model="menuEndDate"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="endDate"
              color="deep-orange darken-1"
              :rules="rules.endDate"
              label="End date"
              prepend-icon="mdi-calendar"
              readonly />
            <v-date-picker v-model="endDate" no-title scrollable actions color="deep-orange darken-1"/>
          </v-menu>
        </v-flex>
        <v-flex xs2 md1 px-2>
          <v-btn
            :disabled="!form.valid"
            :loading="form.loading"
            type="submit"
            color="tertiary"
            alt="Atualizar"
            class="mx-0 font-weight-light right"
            style="padding:12px 12px!important;min-width:50px!important;"
          >
            <v-icon color="primary">mdi-filter</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- End global filters -->
  </v-container>
</template>darken

<script>
const moment = require('moment')

export default {
  data: () => ({
    startDate: '',
    menuStartDate: false,
    endDate: '',
    menuEndDate: false,
    form: {
      loading: false,
      disabled: false,
      valid: false
    },
    rules: {
      startDate: [v => !!v || 'Informe uma data inicial'],
      endDate: [v => !!v || 'Informe uma data final']
    }
  }),
  beforeMount () {
    this.startDate = moment().format('YYYY-MM-DD')
    this.endDate = moment().format('YYYY-MM-DD')

    this.retrieveFilterParams()
  },
  methods: {
    apply: function () {
      this.form.loading = true
      if (this.$refs.form.validate()) {
        let startDate = this.startDate
        let endDate = this.endDate

        this.$store.dispatch('filters/applyFilter', {
          startDate: startDate,
          endDate: endDate
        })
      }

      this.$router.go()
    },
    retrieveFilterParams: function () {
      this.startDate = this.$store.state.filters.startDate
      this.endDate = this.$store.state.filters.endDate
    }
  }
}
</script>

<style>
.v-date-picker-table--date tbody td {
  padding: 0 !important;
}
</style>
